module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-2-th.653bd4e.png";